import React from 'react'

import {
  hitEmployeeMax,
  hitGeneralAdmissionMax,
  hitMembershipMax,
  hitSpecificConstituencyMax,
  GENERAL_CAP
} from '../helpers/logic'
import GroupsContact from './groups-contact'

function CapacityMessage({
  event,
  remainingTickets,
  hasActiveMembership,
  manualMaximum = null,
  showMembershipMessaging = false
}) {
  const employeeMax = hitEmployeeMax(
    event,
    remainingTickets.remainingEmployeeTickets
  )
  const membershipMax =
    hasActiveMembership &&
    hitMembershipMax(event, remainingTickets.remainingMembershipTickets)

  const specificConstituencyMax = hitSpecificConstituencyMax(
    event,
    remainingTickets.remainingConstituencyTickets
  )

  const displayConstituencyMax = () => {
    return specificConstituencyMax.map(pt => {
      return (
        <p
          className="font-bold text-16"
          key={`capacity-message-${pt.id}`}
        >
          You've reached your {pt.priceTypeName} limit and cannot add more.
        </p>
      )
    })
  }

  const generalAdmissionMax = hitGeneralAdmissionMax(event)

  return (
    <React.Fragment>
      {manualMaximum && (
        <p className="font-bold text-16">
          You have updated all the reserved tickets in your cart. Please
          continue.
        </p>
      )}
      {generalAdmissionMax && <GroupsContact generalCap={GENERAL_CAP} />}
      {employeeMax && (
        <p className="font-bold text-16">
          You are currently at your limit for staff and volunteer tickets for
          this day and cannot add more to your order.
        </p>
      )}
      {membershipMax && showMembershipMessaging && (
        <p className="font-bold text-16">
          Membership allotment reached. You currently have your full Adult
          Member ticket allotment reserved for this event.
        </p>
      )}
      {specificConstituencyMax?.length > 0 && displayConstituencyMax()}
    </React.Fragment>
  )
}

export default CapacityMessage
